'use strict';

var base = require('~/product/base');
var detail = require('base:product/detail');
var carouselHelper = require('~/components/carousel');
var $clamp = require('clampjs');

/**
 * Update availability on change event on quantity selector and on store:afterRemoveStoreSelection event.
 * If store has been selected, exit function otherwise proceed to update attributes.
 * @param {Object} element DOM Element.
 */
function updateAvailability(element) {
    var searchPID = $(element).closest('.product-detail').attr('data-pid');
    var selectorPrefix = '.product-detail[data-pid="' + searchPID + '"]';
    if ($(selectorPrefix + ' .selected-store-with-inventory').is(':visible')) {
        return;
    }

    var $productContainer = $(element).closest('.product-detail');
    if (!$productContainer.length) {
        $productContainer = $(element).closest('.modal-content').find('.product-quickview');
    }

    if ($('.bundle-items', $productContainer).length === 0) {
        base.attributeSelect($(element).find('option:selected').data('url'),
            $productContainer);
    }
}

/**
 * Registering on change event on quantity selector. If store has been selected, exist function,
 * otherwise proceed to update attributes.
 */
function availability() {
    $(document).on('change', '.quantity-select', function (e) {
        e.preventDefault();

        updateAvailability($(this));
    });

    $(document).on('store:afterRemoveStoreSelection', function (e, element) {
        e.preventDefault();
        updateAvailability(element);
    });
}

/**
 * Register custom events
 */
function customEvents() {
    $(window).on('scroll', function () {
        $('.product-carousel-container .carousel-container').css('min-height', '');
        var mainProductImageHeight = $('.product-carousel-container .carousel-container > div').height();
        $('.product-carousel-container .carousel-container').css('min-height', mainProductImageHeight);
    });

    $(window).on('resize', function () {
        $('.product-carousel-container .carousel-container').css('min-height', '');
    });
    if ($('.product-reco-upsell').height() > 0 && $('.product-reco-upsell').is(':visible')) {
        $('.lens-technology-description').css('min-height', 425);
    }
}

/**
 * Dynamically update PDP Main info container width and trigger the calculation of the Primary Container
 */
function stickyProductInfo() {
    if ($('.product-sunglasses-context').length > 0) {
        $(window).on('scroll resize', function () {
            calculatePositionPrimaryFixedContainer($(this).scrollTop());
        });
        $(window).on('load resize', function () {
            $(window).trigger('scroll');
        });
        $('.lens-technology-carousel:visible').slick('refresh');
    }
}

/**
 * Display lense technology By Filter
 */
function displayLenseTechnologyByFilter() {
    $('.filter-by-lens-technology-list').on('click', 'li > a', function (e) {
        e.preventDefault();
        $('.filter-by-lens-technology-list li').removeClass('active');
        $(this).parent().addClass('active');
        $('.lens-technology-description-variation').removeClass('d-none d-flex').addClass('d-none');
        var currentLensTechnology = $(this).attr('data-lenstechnology');
        $('.lens-technology-description .variation-' + escapeSpecialChar(currentLensTechnology)).removeClass('d-none').addClass('d-flex');
        $('.filter-by-lens-technology-select').val(currentLensTechnology);

        $('.variant-technology-image a:visible').first().trigger('click');

        if ($('.lens-technology-carousel:visible .slick-track').length > 0) {
            $('.lens-technology-carousel:visible').slick('slickGoTo', 0).slick('refresh');
        } else {
            carouselHelper.methods.initLensTechnologyCarousel($('.lens-technology-carousel:visible'));
        }
        touchEndDetected = false;
        clickDetected = false;
    });

    $('.filter-by-lens-technology-select').on('change', function() {
        var currentSelectedTechnology = $(this).val();
        $('.filter-by-lens-technology-list li a[data-lenstechnology=\'' + currentSelectedTechnology + '\']').click();
    });

    var touchEndDetected = false;
    var clickDetected = false;

    $('.filter-by-lens-technology-list li').on('click mouseover touchend', function (e) {
        if (e.type === 'touchend' || e.type === 'click') {
            touchEndDetected = true;
            clickDetected = true;
        }

        if (!touchEndDetected && !clickDetected && $(window).width() > 768) {
            var lensTechnologyHover = $(this).find('.asset-lens-technology');
            lensTechnologyHover.removeAttr('style');
            lensTechnologyHover
                .css('width', $('.variant-technology-asset:visible').width())
                .css('top', -lensTechnologyHover.outerHeight() - 10)
                .css('margin-left', (-(lensTechnologyHover.width() / 2) + ($(this).width() / 2)))
                .removeClass('d-none');

            touchEndDetected = false;
            clickDetected = false;
        }
    });

    $('.filter-by-lens-technology-list li').on('mouseleave', function (e) {
        $(this).find('.asset-lens-technology').addClass('d-none');
    });

    $(window).on('resize', function () {
        touchEndDetected = false;
        clickDetected = false;
    });
}

/**
 * Display lense technology By Image Variation
 */
function displayLenseTechnologyByImageVariation() {
    $('.variant-technology-image').on('click', 'a', function (e) {
        e.preventDefault();
        var $currentLensTechnologyItem = $(this);

        // deselect other lens variant images and mark the current item as selected
        $('.variant-technology-image').removeClass('active');
        $currentLensTechnologyItem.parent().addClass('active');

        // get the attribute from the lens
        var currentLensTechnologyItemAttribute = $currentLensTechnologyItem.attr('data-color-variant');

        // set classes for the lens tabs section, make sure only the current tab is visible
        $('.variant-technology-description').removeClass('active d-flex').addClass('d-none');
        var $newSectionToDisplay = $currentLensTechnologyItem.closest('.lens-technology-description-variation').find('.variant-technology-description[data-color-variant=\'' + currentLensTechnologyItemAttribute + '\']').first();
        $newSectionToDisplay.removeClass('d-none').addClass('active d-flex');

        $('.filter-by-lens-technology-list').addClass('no-refresh');

        // trigger the click on the button corresponding to this colour
        var variationButton = $("#color-variations-wrapper > button[data-color-variant='" + currentLensTechnologyItemAttribute + "']");
        $(variationButton).trigger('click');
    });
}

/**
 * Escape String for special Characters
 * @param {*} str
 * @returns
 */
function escapeSpecialChar(str) {
    return str.replace(/\+/g, '\\+');
}

/**
 * Calculate of the Primary Container to define when the fixed container should become relative on scroll.
 */
function calculatePositionPrimaryFixedContainer(scrollTop) {
    var containerWidth = $('.pdp-primary-info').innerWidth() - 30; // substract padding
    $('.pdp-primary-info-fixed-container').width(containerWidth);

    if ($(window).width() > 768) {
        var descriptionSectionOffset = $('.description-and-detail').offset();
        var margin = 40;
        var currentScrollPosition = scrollTop + $('.pdp-primary-info-fixed-container').height() + $('.product-carousel-container').offset().top;
        var lensTechnoBottomPosition = $('.lens-technology-section').offset().top + $('.lens-technology-section').height() - margin;
        if ((currentScrollPosition) > lensTechnoBottomPosition) {
            $('.pdp-primary-info').css('max-height', '0px');
            var topPosition = descriptionSectionOffset.top - $('.pdp-primary-info-fixed-container').height() - $('.product-carousel-container').offset().top - margin;
            $('.pdp-primary-info-fixed-container').removeClass('position-fixed').addClass('position-relative').css('top', topPosition);
        } else if ($('.pdp-primary-info-fixed-container.position-fixed').length === 0) {
            $('.pdp-primary-info-fixed-container').addClass('position-fixed').removeClass('position-relative').css('top', '');
        }
    } else {
        $('.pdp-primary-info-fixed-container').removeClass('position-fixed').removeClass('position-relative').css('top', '');
        $('.pdp-primary-info').css('max-height', '');
    }
}

/**
 * Toggle read more button on lens description
 */
function readMoreLensDescription() {
    var $variantLensDescription = $('.variant-lens-attribute-lensdescription');
    if ($variantLensDescription.length > 0) {
        $(window).on('load resize', function () {
            $variantLensDescription.each(function (index, element) {
                if ($(window).width() <= 543) {
                    if ($('.read-less-txt:visible').length > 0) {
                        return;
                    }
                    $clamp(element, { clamp: 2 });
                    if ($variantLensDescription.css('overflow') === 'hidden') {
                        $('.read-more-txt').removeClass('d-none');
                        $('.read-less-txt').addClass('d-none');
                    } else {
                        $('.read-more-txt').addClass('d-none');
                        $('.read-less-txt').addClass('d-none');
                    }
                } else {
                    $variantLensDescription.removeAttr('style');
                    $('.read-more-txt').addClass('d-none');
                    $('.read-less-txt').addClass('d-none');
                }
            });
        });

        $('.read-more-txt').on('click', function () {
            $(this).addClass('d-none');
            $(this).parent().find('.read-less-txt').removeClass('d-none');
            $(this).parent().prev('.variant-lens-attribute-lensdescription').removeAttr('style');
        });

        $('.read-less-txt').on('click', function () {
            $(this).parent().find('.read-more-txt').removeClass('d-none');
            $(this).addClass('d-none');
            $clamp($(this).parent().prev('.variant-lens-attribute-lensdescription')[0], { clamp: 2 });
        });
    }
}

/**
 * Init upsell feature events
 */
function upsellEvents() {
    $('body').on('click', '.js-add-to-cart-upsell', function (e) {
        e.preventDefault();
        let addToCartUrl = $('.add-to-cart-url').val();
        let $this = $(this);

        if (!addToCartUrl) {
            return;
        }

        var $rxb2cModal = $('#rxB2CAddToCartModal');
        if ($rxb2cModal.length && $('input[name="currentCartIsRX"]', $rxb2cModal).val() === 'true' && $('input[name="customerConfirmSubmit"]', $rxb2cModal).val() !== 'true') {
            $('body').trigger('rxb2c:openconfirmationmodal', {
                actionTarget: $this
            });
            return;
        }

        $.ajax({
            method: 'post',
            url: addToCartUrl,
            data: {
                quantity: 1,
                pid: $(this).attr('data-upsell-pid')
            },
            success: function (data) {
                if (!data.error) {
                    $('.minicart').trigger('count:update', data);
                    $('body').trigger('cart:update');
                }
            }
        });
    });
}

var exportDetails = $.extend({}, detail, {
    availability: availability,
    init: base.init,
    stickyProductInfo: stickyProductInfo,
    displayLenseTechnologyByFilter: displayLenseTechnologyByFilter,
    displayLenseTechnologyByImageVariation: displayLenseTechnologyByImageVariation,
    readMoreLensDescription: readMoreLensDescription,
    customEvents: customEvents,
    upsellEvents: upsellEvents
});

module.exports = exportDetails;
